import React from "react";
import { Button } from "@/shared/ui/button"
import { ArrowLeft, Save, Trash2 } from "lucide-react";
import ConfirmActionDialog from "@/shared/components/ConfirmActionDialog"
import Loader from '@/shared/components/Loader'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/shared/ui/tooltip"
import { FaQuestion } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

export function TemplateEditorToolbar({
  onBack,
  isReadOnly,
  isDirty,
  isSaving,
  isDeleting,
  onSave,
  onDelete,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={onBack} size="icon">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <TooltipProvider delayDuration={0} skipDelayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="outline"
                size="icon"
                className="rounded-full border border-gray-300 cursor-default"
              >
                <FaQuestion/>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" align="start" className="max-w-[400px] md:max-w-[500px] lg:max-w-[672px]">
              <span className="text-sm font-semibold">{t("profile.templates.editor.helpLabel")}</span>
              <p className="text-sm font-normal">{t("profile.templates.editor.helpTooltip")}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      {!isReadOnly ? (
        <div className="flex items-center gap-2">
          <ConfirmActionDialog
            trigger={
              <Button variant="destructive" disabled={isSaving || isDeleting} size="icon">
                {isDeleting ? <Loader /> : <Trash2 className="h-4 w-4" />}
              </Button>
            }
            title="Delete template?"
            description="This action can’t be undone. This will permanently delete this template."
            confirmText="Delete"
            confirmClassName="bg-red-500 hover:bg-red-500/90"
            onConfirm={onDelete}
            confirmDisabled={isSaving || isDeleting}
          />
          <Button disabled={!isDirty || isSaving || isDeleting} onClick={onSave} size="icon">
            {isSaving ? <Loader /> : <Save className="h-4 w-4" />}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
